
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import List from '@/common/components/UI/List/index.vue'

// module components
import SettingsListItem from '@/modules/SettingsModule/components/SettingsListItem/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { SettingT } from '@/core/types/settings.types'

// realisation
import { settings } from '@/core/realisations/settings.realisation'

// composable
import useHelpers from '@/common/composable/useHelpers'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'failed-fetch': FailedFetch,
        list: List,
        'settings-list-item': SettingsListItem,
    },
    setup() {
        const state = reactive(new DataState<SettingT>({}))

        const loadSettings = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true

                const response = await settings.getList({ page })
                state.list = response.data
                state.pagination.total_pages = response.meta.last_page

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        onBeforeMount(() => {
            loadSettings(1)
        })

        const { findItemIndexById } = useHelpers()

        const onSettingEnabled = (setting_id: number) => {
            const index = findItemIndexById(setting_id, state.list)
            if (index < 0) return

            state.list[index].value = '1'
        }

        const onSettingDisabled = (setting_id: number) => {
            const index = findItemIndexById(setting_id, state.list)
            if (index < 0) return

            state.list[index].value = '0'
        }

        return { state, loadSettings, onSettingEnabled, onSettingDisabled }
    },
})
